import { render, staticRenderFns } from "./BroadcastItem.vue?vue&type=template&id=b5a2c142&scoped=true"
import script from "./BroadcastItem.vue?vue&type=script&lang=js"
export * from "./BroadcastItem.vue?vue&type=script&lang=js"
import style0 from "./BroadcastItem.vue?vue&type=style&index=0&id=b5a2c142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a2c142",
  null
  
)

export default component.exports